import React, {Component} from 'react';
import './OverviewScreenWidget.css';
import PropTypes from 'prop-types';
import ArrowLink from "../../Common/ArrowLink";

export default class OverviewScreenWidget extends Component {
    render() {
        return (
            <div className={"OverviewScreenWidget"}>
                <div className={"OverviewScreenWidget__inner"}>
                    <h2 className={"OverviewScreenWidget__title"}>
                        <i className={"mdi mdi-" + this.props.iconName}/>
                        <span>{this.props.title}</span>
                    </h2>
                    <p className={"generic"}>{this.props.text}</p>
                </div>
                <div className={"OverviewScreenWidget__status"}>
                    {this.props.children}
                    {this.props.linkTo &&
                    <div className={"OverviewScreen__subw"}>
                        <ArrowLink label={"Bekijk " + this.props.title.toLowerCase()}
                                   to={this.props.linkTo} routerLink={true}/>
                    </div>
                    }
                </div>
            </div>
        );
    }
}

OverviewScreenWidget.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    linkTo: PropTypes.string,
    iconName: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/Portal/Overview/OverviewScreenWidget.js